import { selectCurrentHotelId } from 'accessors'
import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TryLoginDialog from 'components/TryLoginDialog'
import { PMSsWithSyncLoginSupport, userEmailsRestartPMS } from 'constants/index'
import download from 'js-file-download'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications/dist/ToastProvider'
import dashboardApi from 'services/api/dashboard'
import internalOnlyApi from 'services/api/internalOnly'
import uploadLogsApi from 'services/api/uploadLogs'

import Loading from '../../components/ReusableComponents/LoadingIndicator'
import Paginator from '../../components/ReusableComponents/Paginator/index'
import GroupedUploadRow from './GropedRow'
import { ReactComponent as RefreshIcon } from './refresh.svg'
import { TitleRow } from './TitleRow'
import Row from './UploadLogRow'
import styles from './UploadLogs.module.scss'

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

function getTab({ category }) {
  if (
    category === 'ReservationsActivityWithContactDetails' ||
    category === 'ReservationOnlyActivity'
  ) {
    return 'ReservationsAndCancellations'
  }
  if (category === 'CheckoutActivityWithContactDetails') {
    return 'Checkouts'
  }
  if (category === 'GuestProfile') {
    return 'GuestProfile'
  }
  if (category === 'EnrichBookings') {
    return 'EnrichBookings'
  }
  return 'Others'
}

const handleDownloadData = async (historyId, uploadHistoryKind, category) => {
  const log = await dashboardApi.downloadUploadLog(historyId, uploadHistoryKind, category)

  let fileName = `log-${historyId}.xml`

  if (category !== 'OriginalUpload') {
    fileName = `log-${historyId}.csv`
  }

  if (category === 'OriginalUpload' && uploadHistoryKind === 'Invite') {
    fileName = `log-${historyId}.csv`
  }

  download(log.data, fileName)
}

const UploadLogs = ({ dispatch, subsidiaryPMS, currentHotelId }) => {
  const [activeTab, setActiveTab] = useState()
  const [groupedLogs, setGroupedLogs] = useState()

  const { isInternalAdmin } = useSelector(s => s.login)

  const [isErred, setIsErred] = useState()

  const [logs, setLogs] = useState()
  const [isLoading, setIsLoading] = useState()
  const [lastUpdated, setLastUpdated] = useState()

  const [month, setMonth] = useState(moment().month() + 1)
  const [year, setYear] = useState(moment().year())

  function getLogs() {
    setIsLoading(true)
    uploadLogsApi
      .get({ month, year })
      .then(res => {
        setLogs(res.map(d => ({ ...d, tab: getTab(d) })))
        setLastUpdated(new Date().toJSON())
      })
      .catch(() => {
        setIsErred(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    setIsLoading(true)
    uploadLogsApi
      .get({ month, year })
      .then(res => {
        setLogs(res.map(d => ({ ...d, tab: getTab(d) })))
        setLastUpdated(new Date().toJSON())
      })
      .catch(() => {
        setIsErred(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [dispatch, currentHotelId, month, year])

  useEffect(() => {
    if (logs && logs.length > 0) {
      setActiveTab(logs[0].tab)
    }
  }, [logs])

  useEffect(() => {
    if (activeTab) {
      if (logs && logs.length && subsidiaryPMS === 'opera') {
        const tempArr = []

        const groupedLogs = logs
          .filter(log => log.tab === activeTab)
          .reduce((arr, log) => {
            const day = moment(log.uploadedOn).format('$DD_MM')
            if (!tempArr.includes(day)) {
              tempArr.push(day)
              arr[tempArr.findIndex(el => el === day)] = []
            }
            arr[tempArr.findIndex(el => el === day)].push(log)

            return arr
          }, [])

        setGroupedLogs(groupedLogs)
      }
    }
  }, [subsidiaryPMS, currentHotelId, logs, activeTab])

  const LTab = ({ cat, children }) =>
    logs && logs.filter(log => log.tab === cat).length > 0 ? (
      <Tab isActive={activeTab === cat} handleClick={() => setActiveTab(cat)}>
        {children}
      </Tab>
    ) : null

  const isUsingDefaultReports = logs?.some(l => l.category === 'GuestProfile')

  const login = useSelector(state => state.login)

  const subsidiaryId = useSelector(selectCurrentHotelId)

  const [reEnablingPmsSync, setReEnablingPmsSync] = useState(false)

  const [isTryLoginDialogVisible, setIsTryLoginDialogVisible] = useState(false)
  const [isTryingLogin, setIsTryingLogin] = useState(false)
  const [tryLoginResponse, setTryLoginResponse] = useState(null)
  const [isTryLoginSuccessful, setIsTryLoginSuccessful] = useState()

  function tryLogin() {
    setIsTryLoginDialogVisible(true)
    setIsTryingLogin(true)

    internalOnlyApi
      .tryLogin({ subsidiaryId })
      .then(res => {
        setTryLoginResponse(res)
        setIsTryLoginSuccessful(true)
      })
      .catch(err => {
        setTryLoginResponse(err)
        setIsTryLoginSuccessful(false)
      })
      .finally(() => {
        setIsTryingLogin(false)
      })
  }

  function closeTryLoginDialog() {
    setIsTryLoginDialogVisible(false)
    setTryLoginResponse(null)
    setIsTryLoginSuccessful(null)
  }

  const { addToast } = useToasts()

  if (isLoading) {
    return (
      <div style={{ height: 100 }}>
        <Loading />
      </div>
    )
  }

  if (isErred) {
    return <div>Something went wrong</div>
  }

  const canReEnablePMS =
    login.isInternalAdmin &&
    userEmailsRestartPMS.includes(login.currentUser.email) &&
    PMSsWithSyncLoginSupport.includes(subsidiaryPMS)

  function reEnablePMSSync() {
    setReEnablingPmsSync(true)

    internalOnlyApi
      .reEnablePMSSync(subsidiaryId)
      .then(() => {
        addToast('PMS sync re-enabled', { appearance: 'success', autoDismiss: true })
      })
      .catch(err => {
        addToast(err.toString(), { appearance: 'error' })
      })
      .finally(() => {
        setReEnablingPmsSync(false)
      })
  }

  return (
    <div className={styles.container}>
      {isTryLoginDialogVisible && (
        <TryLoginDialog
          isTryLoginSuccessful={isTryLoginSuccessful}
          isTryingLogin={isTryingLogin}
          onClose={closeTryLoginDialog}
          response={tryLoginResponse}
        />
      )}
      <CustomHeader
        title="Upload logs"
        subtitle={`Last updated on: ${moment(lastUpdated).format('HH:mm:ss')}`}
        width={1000}
      >
        <RefreshIcon onClick={getLogs} className={styles.refreshIcon} />
      </CustomHeader>

      {logs?.length === 0 && (
        <div>
          <div className={styles.filters}>
            <Dropdown
              value={month}
              options={
                year === moment().year()
                  ? Array(moment().month() + 1)
                      .fill(0)
                      .map((_, i) => moment().subtract(i, 'months').month() + 1)
                      .reduce(
                        (acc, month) => ({ ...acc, [month]: monthNames[month - 1] }),
                        {}
                      )
                  : monthNames.reduce((acc, month, i) => ({ ...acc, [i + 1]: month }), {})
              }
              onChange={e => setMonth(e.target.value)}
              isSortedAlphabetically={false}
            />
            <Dropdown
              isSortedAlphabetically={false}
              value={year}
              onChange={e => setYear(e.target.value)}
              options={Array(8)
                .fill(0)
                .map((_, i) => moment().subtract(i, 'years').year())
                .reduce((acc, year) => ({ ...acc, [year]: year }), {})}
            />
          </div>
          <div className={styles.noLogs}>No logs found</div>
        </div>
      )}
      {logs && logs.length !== 0 && (
        <>
          <Tabs>
            <LTab cat="Checkouts">Checkouts</LTab>
            <LTab cat="ReservationsAndCancellations">
              Reservations &amp; Cancellations
            </LTab>
            <LTab cat="GuestProfile">Guest profile</LTab>
            <LTab cat="Others">Others</LTab>
            <LTab cat="EnrichBookings">Enriched bookings</LTab>
            {canReEnablePMS && (
              <div className={styles.pmsControls}>
                <button className={styles.renableSyncButton} onClick={reEnablePMSSync}>
                  <RefreshIcon className={reEnablingPmsSync ? styles.spin : ''} />
                  Re-enable Sync
                </button>
                <button className={styles.renableSyncButton} onClick={tryLogin}>
                  Try login
                </button>
              </div>
            )}
            <div className={styles.filters}>
              <Dropdown
                value={month}
                options={
                  year === moment().year()
                    ? Array(moment().month() + 1)
                        .fill(0)
                        .map((_, i) => moment().subtract(i, 'months').month() + 1)
                        .reduce(
                          (acc, month) => ({ ...acc, [month]: monthNames[month - 1] }),
                          {}
                        )
                    : monthNames.reduce(
                        (acc, month, i) => ({ ...acc, [i + 1]: month }),
                        {}
                      )
                }
                onChange={e => setMonth(e.target.value)}
                isSortedAlphabetically={false}
              />
              <Dropdown
                isSortedAlphabetically={false}
                value={year}
                onChange={e => setYear(e.target.value)}
                options={Array(8)
                  .fill(0)
                  .map((_, i) => moment().subtract(i, 'years').year())
                  .reduce((acc, year) => ({ ...acc, [year]: year }), {})}
              />
            </div>
          </Tabs>
          <TitleRow />
          {subsidiaryPMS === 'opera' ? (
            groupedLogs &&
            groupedLogs.map(group => (
              <GroupedUploadRow
                key={group[0].inviteUploadHistoryId}
                logGroup={group}
                handleDownloadData={handleDownloadData}
                isAdminMode={isInternalAdmin}
                subscriberLabel={isUsingDefaultReports ? 'bookings' : 'subscribed guests'}
              />
            ))
          ) : (
            <>
              <Paginator>
                {logs
                  .filter(log => log.tab === activeTab)
                  .map(log => (
                    <Row
                      {...log}
                      key={log.inviteUploadHistoryId}
                      handleDownloadData={handleDownloadData}
                      isAdminMode={isInternalAdmin}
                    />
                  ))}
              </Paginator>
            </>
          )}
        </>
      )}
    </div>
  )
}

const Tab = ({ handleClick, children, isActive }) => (
  <button
    className={[styles.tab, isActive ? styles.active : ''].join(' ')}
    onClick={handleClick}
  >
    {children}
  </button>
)

const Tabs = ({ children }) => <div className={styles.tabs}>{children}</div>

const mapStateToProps = ({ autoInvite, login }) => ({
  logs: autoInvite.uploadLogsData,
  lastUpdated: autoInvite.lastUpdated,
  subsidiaryPMS: login.subsidiaryPMS,
  currentHotelId: login.currentHotelId
})

export default withRouter(connect(mapStateToProps)(UploadLogs))
